import { render } from "./editDataList.vue?vue&type=template&id=6d4e2fc7&scoped=true"
import script from "./editDataList.vue?vue&type=script&lang=js"
export * from "./editDataList.vue?vue&type=script&lang=js"

import "./editDataList.vue?vue&type=style&index=0&id=6d4e2fc7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d4e2fc7"

export default script